// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSecao_hero__e2uYH {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.HeroSecao_fundoImagem__yzxro {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.HeroSecao_fundoImagem__yzxro img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
}

.HeroSecao_gradienteSobreposicao__erdgk {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    hsl(222, 47%, 6%, 0.3) 0%,
    hsl(222, 47%, 6%, 0.8) 60%,
    hsl(222, 47%, 6%, 1) 100%
  );
}

.HeroSecao_conteudo__ck\\+yb {
  position: relative;
  z-index: 10;
  text-align: center;
  max-width: 800px;
  padding: 0 1.5rem;
}

.HeroSecao_etiqueta__Xoxi1 {
  display: inline-block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  font-weight: 500;
  color: hsl(217, 91%, 60%);
  background: hsl(217, 91%, 60%, 0.1);
  border: 1px solid hsl(217, 91%, 60%, 0.2);
  padding: 0.4rem 1rem;
  border-radius: 999px;
  margin-bottom: 1.5rem;
  letter-spacing: 0.05em;
}

.HeroSecao_nome__FOWkN {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1rem;
  color: hsl(210, 40%, 95%);
}

.HeroSecao_nomeDestaque__XwwC1 {
  background: linear-gradient(135deg, hsl(217, 91%, 65%), hsl(250, 70%, 65%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.HeroSecao_titulo__ejl8d {
  font-size: 1.25rem;
  font-weight: 400;
  color: hsl(215, 20%, 55%);
  margin-bottom: 0.75rem;
  line-height: 1.6;
}

.HeroSecao_descricao__sPkat {
  font-size: 1rem;
  color: hsl(215, 20%, 45%);
  margin-bottom: 2.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.7;
}

.HeroSecao_botoes__OuGkZ {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.HeroSecao_botaoPrimario__BBQHC {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 2rem;
  background: linear-gradient(135deg, hsl(217, 91%, 60%), hsl(250, 70%, 60%));
  color: hsl(0, 0%, 100%);
  border: none;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  box-shadow: 0 0 30px hsl(217, 91%, 60%, 0.2);
}

.HeroSecao_botaoPrimario__BBQHC:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 40px hsl(217, 91%, 60%, 0.35);
}

.HeroSecao_botaoSecundario__2K5Ap {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 2rem;
  background: transparent;
  color: hsl(210, 40%, 92%);
  border: 1px solid hsl(222, 30%, 22%);
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.HeroSecao_botaoSecundario__2K5Ap:hover {
  border-color: hsl(217, 91%, 60%);
  background: hsl(217, 91%, 60%, 0.05);
  transform: translateY(-2px);
}

.HeroSecao_indicadorScroll__RzEVk {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: hsl(215, 20%, 40%);
  font-size: 0.75rem;
  animation: HeroSecao_float__xkZrq 3s ease-in-out infinite;
}

@keyframes HeroSecao_float__xkZrq {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50% { transform: translateX(-50%) translateY(-8px); }
}

.HeroSecao_setaBaixo__U2t6Q {
  width: 1.25rem;
  height: 1.25rem;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .HeroSecao_nome__FOWkN {
    font-size: 2.5rem;
  }

  .HeroSecao_titulo__ejl8d {
    font-size: 1rem;
  }

  .HeroSecao_descricao__sPkat {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroSecao/HeroSecao.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,2EAA2E;EAC3E,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yDAAwC;AAC1C;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".hero {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.fundoImagem {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.fundoImagem img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.4;\n}\n\n.gradienteSobreposicao {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    hsl(222, 47%, 6%, 0.3) 0%,\n    hsl(222, 47%, 6%, 0.8) 60%,\n    hsl(222, 47%, 6%, 1) 100%\n  );\n}\n\n.conteudo {\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  max-width: 800px;\n  padding: 0 1.5rem;\n}\n\n.etiqueta {\n  display: inline-block;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: hsl(217, 91%, 60%);\n  background: hsl(217, 91%, 60%, 0.1);\n  border: 1px solid hsl(217, 91%, 60%, 0.2);\n  padding: 0.4rem 1rem;\n  border-radius: 999px;\n  margin-bottom: 1.5rem;\n  letter-spacing: 0.05em;\n}\n\n.nome {\n  font-size: 4rem;\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 1rem;\n  color: hsl(210, 40%, 95%);\n}\n\n.nomeDestaque {\n  background: linear-gradient(135deg, hsl(217, 91%, 65%), hsl(250, 70%, 65%));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.titulo {\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: hsl(215, 20%, 55%);\n  margin-bottom: 0.75rem;\n  line-height: 1.6;\n}\n\n.descricao {\n  font-size: 1rem;\n  color: hsl(215, 20%, 45%);\n  margin-bottom: 2.5rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.7;\n}\n\n.botoes {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.botaoPrimario {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 2rem;\n  background: linear-gradient(135deg, hsl(217, 91%, 60%), hsl(250, 70%, 60%));\n  color: hsl(0, 0%, 100%);\n  border: none;\n  border-radius: 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  box-shadow: 0 0 30px hsl(217, 91%, 60%, 0.2);\n}\n\n.botaoPrimario:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 40px hsl(217, 91%, 60%, 0.35);\n}\n\n.botaoSecundario {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 2rem;\n  background: transparent;\n  color: hsl(210, 40%, 92%);\n  border: 1px solid hsl(222, 30%, 22%);\n  border-radius: 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.botaoSecundario:hover {\n  border-color: hsl(217, 91%, 60%);\n  background: hsl(217, 91%, 60%, 0.05);\n  transform: translateY(-2px);\n}\n\n.indicadorScroll {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  color: hsl(215, 20%, 40%);\n  font-size: 0.75rem;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateX(-50%) translateY(0); }\n  50% { transform: translateX(-50%) translateY(-8px); }\n}\n\n.setaBaixo {\n  width: 1.25rem;\n  height: 1.25rem;\n  opacity: 0.5;\n}\n\n@media (max-width: 768px) {\n  .nome {\n    font-size: 2.5rem;\n  }\n\n  .titulo {\n    font-size: 1rem;\n  }\n\n  .descricao {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `HeroSecao_hero__e2uYH`,
	"fundoImagem": `HeroSecao_fundoImagem__yzxro`,
	"gradienteSobreposicao": `HeroSecao_gradienteSobreposicao__erdgk`,
	"conteudo": `HeroSecao_conteudo__ck+yb`,
	"etiqueta": `HeroSecao_etiqueta__Xoxi1`,
	"nome": `HeroSecao_nome__FOWkN`,
	"nomeDestaque": `HeroSecao_nomeDestaque__XwwC1`,
	"titulo": `HeroSecao_titulo__ejl8d`,
	"descricao": `HeroSecao_descricao__sPkat`,
	"botoes": `HeroSecao_botoes__OuGkZ`,
	"botaoPrimario": `HeroSecao_botaoPrimario__BBQHC`,
	"botaoSecundario": `HeroSecao_botaoSecundario__2K5Ap`,
	"indicadorScroll": `HeroSecao_indicadorScroll__RzEVk`,
	"float": `HeroSecao_float__xkZrq`,
	"setaBaixo": `HeroSecao_setaBaixo__U2t6Q`
};
export default ___CSS_LOADER_EXPORT___;
